// /apps/$appId — the deployments panel for a single built app (deployApp v2
// arc). Sibling of routes/apps-page.tsx (/apps list); mounts the client
// component directly and threads `$appId` from TanStack's synchronous route
// params, the same shape routes/arena-detail.tsx uses. Registered from
// routes/agents.tsx under the `_authed` guard.
import { createRoute } from '@tanstack/react-router';
import { AppDetailClient } from '@/app/apps/[id]/app-detail-client';
import { authedRoute } from './guards';

function AppDetailRoute() {
  const { appId } = appDetailRoute.useParams();
  return <AppDetailClient appId={appId} />;
}

export const appDetailRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/apps/$appId',
  component: AppDetailRoute,
});
